//@flow
import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import * as Immutable from 'immutable';

import { BusinessUnit } from 'common/models/internal/BusinessUnits';
import { clientBusinessUnitsSelector } from 'common/redux/selectors/intl';

import { translate } from 'react-i18next';

import EntityIdInput from 'common/entity/generic/EntityIdInput';

type Props = {
    onChange: (?BusinessUnit) => void,
    businessUnits: Immutable.List<BusinessUnit>,
    field: { placeholder: string },
    businessUnit: BusinessUnit,
    t: string => string
};

type State = {
    businessUnits: Immutable.List<?BusinessUnit>
};

class BusinessUnitIdInput extends Component<Props, State> {
    state = { businessUnits: Immutable.List() };

    loadOptions = (input: string, callback) => {
        const { businessUnits } = this.props;
        let businessUnitsArray = businessUnits.toJS();
        if (input) {
            businessUnitsArray = businessUnits.filter(
                ({ name, businessUnitId }) =>
                    name.includes(input) || businessUnitId.includes(input)
            );
        }
        this.setState({ businessUnits: businessUnitsArray });
        callback(businessUnitsArray);
    };

    onChange = value => {
        const { onChange } = this.props;
        let businessUnit = null;
        if (value) {
            businessUnit = BusinessUnit.fromJS(value);
        }
        onChange(businessUnit);
    };

    getOptionLabelAndValue = option => option.businessUnitId;

    render() {
        const {
            businessUnit,
            field: { placeholder },
            t,
            ...rest
        } = this.props;
        const { businessUnits } = this.state;
        return (
            <EntityIdInput
                {...rest}
                onChange={this.onChange}
                options={businessUnits}
                value={businessUnit}
                placeholder={t(placeholder)}
                loadOptions={this.loadOptions}
                getOptionLabelAndValue={this.getOptionLabelAndValue}
            />
        );
    }
}

const mapStateToProps = (state, props) => {
    const { businessUnits } = clientBusinessUnitsSelector(state, props);
    return {
        businessUnits
    };
};

const withRedux = connect(mapStateToProps);
export default compose(
    withRedux,
    translate('entityManagement')
)(BusinessUnitIdInput);
